import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '@shared/session.service';

export const adminGuard: CanActivateFn = (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router: Router = inject(Router);
  const sessionService = inject(SessionService);

  if (sessionService.is_admin) {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
